module.exports = __webpack_public_path__ + "static/media/hashtag.356d87ea.svg";